import { RECEIVE_FIELD_PERMISSION } from '../constants/actionTypes';

export function receiveFieldPermission(permission) {
  return {
    type: RECEIVE_FIELD_PERMISSION,
    permission,
  };
}
